<template>
	<article class="public-order-page" style="background: #EFEEF3;">
		<!-- 合作商户信息 -->
		<!-- <publicBusinessInfo :businessImgUrl="businessInfo.LogoUrl == '' ? businessImgUrl : businessInfo.LogoUrl" :businessName="businessInfo.CompanyName"></publicBusinessInfo> -->

		<!-- 用户信息收集 -->
		<!-- <public-order-input
    :inputItems='publicOrderInput'
    :className='uesrOrderInput'
    ></public-order-input> -->

    <img src="../assets/appointmenttop.jpg" style="width: 93%;margin: 5px auto 0;border-radius: 12px;height: 150px;">

		<section :class="['inputs_wrap']" style="border-radius: 16px">
			<div class="user-info-input" style="padding-top: 17px;">
				<span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
					<img src="../assets/cargoplace.png" style="width: 20px;height: 20px;margin-top: -5px;" />
					出发地
				</span>
				<input
          style="width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;"
					readonly="true"
					@click="isGo ? selectstartAddress() : selectEndAddress()"
					class="start-address"
					placeholder="请选择出发地址"
					type="text"
					:value="isGo ? (DefaultAddress ? DefaultAddress.District + '-' + DefaultAddress.Address : '') : endAddress"
				/>
			</div>

			<!-- 交换btn -->
			<!-- <div @click="changeStartEnd" class="exchange text-center">
				<button class="exchange-btn"><i class="iconfont icon-exchange2jiaohuan"></i></button>
			</div> -->

			<div class="user-info-input">
				<span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
					<img src="../assets/cartoplace.png"  style="width: 20px;height: 20px;margin-top: -5px;" />
					目的地
				</span>
				<input
          style="width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;"
					readonly="true"
					@click="isGo ? selectEndAddress() : selectstartAddress()"
					class="end-address"
					placeholder="请选择目的地址"
					type="text"
					:value="isGo ? endAddress : (DefaultAddress ? DefaultAddress.District + '-' + DefaultAddress.Address : '')"
				/>
			</div>

			<div class="user-info-input date-picker">
				<!-- <em style="color: #E22222;">*</em> -->
				<span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
					<img src="../assets/cardate.png" style="width: 20px;height: 20px;margin-top: -5px;" />
					乘车日期
				</span>
        <DatePicker v-model="setDate" @on-change="selectSetDate" :options="disabledselectdate" :clearable="false"  type="date" placeholder="请选择预订日期" style="width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;"></DatePicker>
			</div>

			<div class="user-info-input time-picker">
				<span style="width: 110px;margin-right: 5px;font-weight: bold;color: black;">
					<img src="../assets/cartime.png" style="width: 20px;height: 20px;margin-top: -5px;" />
					期望时间
				</span>
				<span @click="setDateTime" style="color: black; width: 172px;background: #EEEEEE;padding: 4px 10px;border-radius: 30px;">{{ setTime == '' ? '请选择用车时间' : setTime }}</span>
			</div>

      <div class="btn_wrap big-btn"><button class="save_btn" style="background: #356C55;border-radius: 30px;font-size: 20px !important;box-shadow: none;" @click="gotoOrderPage">确认</button></div>

		</section>

		<div style="width: 93%;padding: 0;margin-bottom: 15px;" class="notice reservation_service_notice red_color flex_wrap a_i_center" @click="showWarningTips">
			<Icon type="ios-warning" size="24" color="#F39148" />
			<span style="color: #038AFD;text-decoration: underline;">出行约车须知</span>
		</div>

		<section class="btn_wrap">
			<img style="vertical-align: middle;text-align: center; width: 93%; height: 150px;" src="../assets/appointmentbot.gif" />
		</section>

		<!--服务协议弹出层 Start  -->
		<transition :name="transitionName" mode="out-in">
			<article v-show="showMask" class="mask_wrap" @click.self="showWarningTips">
				<transition name="scale_up" mode="out-in">
					<section v-if="showMask" :class="['mask_container_wrap']">
						<div class="mask_article_wrap">
							<h3 class="article_title">接送车服务须知</h3>
              <div style="width: 100%;border:4px solid #8cc7b1;margin: 10px 0">
                <div style="background: #8cc7b1;padding: 0 10px;color: white;">1、购买服务</div>
                <div style="font-size:13px;color:#888888;padding:10px;">
                  <div>
                    1、当天09:00以前的班车接送，在乘车前一天下午18:00左右通知实际接送乘车时间。
                  </div>
                  <div>
                    2、当天09:00以后的班车接送，在确认订单后通知实际接送乘车时间（18点后下单的，在确认订单后通知）。
                  </div>
                  <div>3、接送服务紧急联系人：王先生 18029902100。</div>
                  <div>4、乘车证件包括但不限于身份证、护照、港澳通行证等。</div>
                  <div>5、预约接送服务需至少提前一天在[中山市旅游集散中心]公众号上提前购买。</div>
                  <div style="text-align: center;"><img style="vertical-align: middle;text-align: center;" src="/../static/img/youtoqrcode.jpg" /><p class="text-center" style="font-size: 13px !important;">请先长按关注公众号以便接收订单消息推送</p></div>
                  <div>
                    6、请旅客收到接送时间后，提前到达接送地点，并保持电话畅通。若您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
                  </div>
                  <div>
                    7、由于旅客自身原因，未能准时到达预约地点的，且未提前联系客服0760-88880777说明原因的，逾时5分钟后视为自动放弃接送服务，接送费用照收，不作另外退还，非司机原因（如堵车、他人责任的交通事故等）造成旅客的延误或其他损失，我方不承担相应的责任。
                  </div>
                  <div>
                    8、服务车型为5座轿车，服务价格以我司移动端现行公示为准，旅客在填写好具体接送地址后及时报价。
                  </div>
                </div>
              </div>

              <div style="width: 100%;border:4px solid #8cc7b1;margin: 10px 0">
                <div style="background: #8cc7b1;padding: 0 10px;color: white;">2、接送车票退改规则</div>
                <div style="font-size:13px;color:#888888;padding:10px;">
                  <div class="table xingli">
                    <ul class="tr bg_th_orderinfo">
                      <li class="th" style="background: #8cc7b1;">退票时间</li>
                      <li class="th" style="background: #8cc7b1;">退票规则</li>
                    </ul>
                    <ul class="tr">
                      <li class="td">未安排车辆前</li>
                      <li class="td">可申请全退包车费用</li>
                    </ul>
                    <ul class="tr">
                      <li class="td">发车前2小时以(内)</li>
                      <li class="td">不得更改或是申请退票</li>
                    </ul>
                    <ul class="tr">
                      <li class="td">发车前2小时以(外)</li>
                      <li class="td">扣50%退票手续费</li>
                    </ul>
                    <ul class="tr">
                      <li class="td">发车前2小时以(外)</li>
                      <li class="td">可免费改签1次</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div style="width: 100%;border:4px solid #8cc7b1;margin: 10px 0">
                <div style="background: #8cc7b1;padding: 0 10px;color: white;">3、注意事项</div>
                <div style="font-size:13px;color:#888888;padding:10px;">
                  <div>
                    1、拼车每人可免费携带26寸以下行李1件(4人同一订单同一地址视为包车,行李总数不超4件)，超出行李（26寸以上按2件计算）按10元/件收取费用，若行李较多可在下单前电话咨询。
                  </div>
                  <div>
                    2、接送服务在未安排车辆和未通知接送时间前，旅客取消接送，不收取接送费；若已安排接送车辆并通知接送时的，由于旅客个人原因，需要取消接送服务的，视为自动放弃接送服务，不作另外退还。
                  </div>
                  <div>3、旅客不得携带危险品或者其他法律、法规规定禁止或不适宜携带的物品搭乘车辆驾驶员的车辆，否则车辆驾驶员有权拒绝提供服务,并由旅客承担任何携带该等物品引起的后果和责任。</div>
                  <div>4、旅客不得在不乘坐车辆的情况下,委托驾驶员单独运送物品。</div>
                  <div>5、旅客不得在使用服务过程中进行违反平台规则的不文明的行为(包括吸烟、喝酒、吐痰、辱骂或殴打驾驶员) ,不得进行或要求车辆驾驶员进行违反相关交通规则或者其他法律法规的行为，因旅客违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的,旅客应向受损方进行赔偿。</div>
                  <div>
                    6、旅客应当具备完全民事行为能力(年满18周岁或年满16周岁、以自己的劳动收入为主要生活来源,且精神健康能完全辨认自己的行为) ,同时,旅客应当保证发布出行信息时是自愿的,且不存在意识不清楚、醉酒等情形。若旅客有意识不清楚、醉酒等情形的，陪同人员代为发布的出行需求信息视为旅客的行为;；在旅客醉酒或存在其他意识不清楚的情况下,应当由意识清楚的第三方陪同;；在旅客饮酒、醉酒或意识不清楚的情况下,给他人造成损失的,旅客本人应当就相应损失予以赔偿。
                  </div>
                </div>
              </div>
						</div>
					</section>
				</transition>
			</article>
		</transition>
		<!--服务协议弹出层 End -->

		<article :class="isShowMap ? 'mask_wrap flex_wrap a_i_center j_c_center mask_show' : 'mask_wrap flex_wrap a_i_center j_c_center'" v-if="isShowMap">
			<section :class="isShowMap ? 'mask_container_mapwrap reservation_service scale_up' : 'mask_container_mapwrap reservation_service'" v-if="isShowMap">
				<i class="iconfont icon-shanchu1" @click="closeConfirmView"></i>
				<div class="weui-cells weui-cells_form" style="margin-top: 0;"><h2 style="color: white;background: #3b9264;margin: 0 0 10px;" class="article_title red_color">请确认行程线路</h2></div>

				<div style="border-radius: 10px;" ref="allMap" id="allMap" v-show="isShowMap"></div>

				<div class="weui-cells weui-cells_form"style="border-radius: 10px;margin: 10px auto 10px;box-shadow: 2px 2px 10px 1px #d5d5d5;">
					<div class="weui-cell" style="background: #8cc8b1;font-size: 16px;color: white;text-align: center;padding: 10px;">
						<div class="weui-cell__hd" style="margin: 0 auto;">时长约：{{ duration }}分钟&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>路程约：{{ kilos }}公里</div>
					</div>
          <div class="weui-cells__group">
          	<div class="weui-cells" style="text-align: center;font-size: 16px;color: #888888;">
          		<i style="color:#ef8878;font-size: 18px;" :class="[isRental == false ? 'iconfont icon-xuanze' : 'iconfont icon-xuanze1']"></i>
          		<input class="input-radio" type="button" @click="setRental(false)" />
          		<label>一口价:<span style="font-weight: bold;color:#000000;font-size:26px !important;">{{ShowCarPoolPrice}}</span>元&nbsp;&nbsp;&nbsp;对比价:{{estimatedAmount}}元</label>
              <!-- <span style="color:red;font-size:19px !important;">{{estimatedAmount}}</span> -->
          	</div>
            <div style="color: #ef8878;text-align: center;border: 1px #ef8878 solid;width: 120px;border-radius: 5px;margin: 5px auto 10px;font-size: 14px;">不含高速桥路费</div>
          </div>
				</div>

				<div class="btn_wrap"><button class="btn inquire_btn" style="background:#3b9264;color: white;border: none;width: 80%;border-radius: 50px;font-size: 20px !important;font-weight: bold;" @click="confirmAddress">确认无误</button></div>

			</section>
		</article>
	</article>
</template>

<script>
import businessApi from '@/request/businessApi';
import appointApi from '@/request/appointApi';
import addressApi from '@/request/addressApi';
import salesApi from '@/request/salesApi';

import Header from './child-components/Header';
import Swiper from './child-components/Swiper';
import publicBusinessInfo from './child-components/publicBusinessInfo';
import InputInfo from './child-components/InputInfo';

import baseTool from '@/utils/baseFunction';

//引入vuex下mapState模块,该模块作用为方便调用state数据,语法糖
import { mapState } from 'vuex';

export default {
	name: 'HqPublicOrderPage',
	data() {
		return {
			startAddress: '',
			endAddress: '',
			businessInfo: {},
			businessImgUrl: '/../static/img/news.gif',
			businessName: '中山港客运码头',
			businessAddressList: [],
			setDate: baseTool.dateFormat(new Date(), 'yyyy-MM-dd'),
      // setDate: Date.parse(new Date()),
			// setTime: baseTool.dateFormat(new Date(), 'HH:mm'),
			setTime: '',
			isGo: true,
			pickupPriceList: [],
			priceTable: [],
			showMask: false,
			transitionName: 'tanchu',
			//合作商户信息:
			name: 'zspassenger',
			avableShowFrequencyTime: '',
			avableShowPickupFrequencyTime: '',
			avableBuyBackPickupTime: '',
			isShowMap: false,
			map: null,
			estimatedAmount: '',
			duration: 0,
			kilos: 0,
			selectedPickupPriceModel: null,
			qrcodeUrl: '../static/img/youtoqrcode.jpg',
			noLimit: false,
			todayAfterSixHour: '',
			nowTime: '',
			nowThreeHoursTime: '',
			fromParams: '',
			myTimer: null,

			isRental: false, // 是否包车
			isAbleToRental: false, // 是否可优惠
			carPoolPrice: 0, // 拼车价
			rentalPrice: 0, //  包车价
			LongDistance: 0,
      ShowCarPoolPrice:'',

      disabledselectdate: {
          disabledDate (date) {
              return date && date.valueOf() < Date.now() - 86400000;
          }
      },
		};
	},
	watch: {
		isRental: function(newval, oldval) {
			// console.log('newval=>', newval);
			// console.log('oldval=>', oldval);
		}
	},
	activated() {
		let that = this;
		//每次加载页面触发
		//通过dispatch调用ticket下actions异步函数中方法,最终改变state里面数据,
		// 第一个参数为方法路径,第二个参数为该方法的实参
		this.computedAvableTime();
		this.tmpTimer = setInterval(() => {
			if (this.$store.state.user.OpenId && this.$store.state.user.OpenId.length > 0) {
				clearInterval(this.tmpTimer);
				// this.$store.dispatch('ticket/getDefaultAddress', this.$store.state.user.OpenId);
				addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
					let result = sucRes;
					if (result.success && result.data.length > 0) {
						for (let i = 0; i < result.data.length; i++) {
							if (result.data[i].IsDefault) {
								this.$store.commit('ticket/setDefaultAddress', result.data[i]);
								this.getPickupPriceList();
								break;
							}
						}
					} else {
						alert('请先添加接送地址信息');
						// this.selectstartAddress();
						this.addNewAddress();
					}
				});

				if (this.$route.params.from && this.$route.params.from.length) {
					this.fromParams = this.$route.params.from;
					salesApi.firstBinding(this.fromParams, this.$store.state.user.OpenId).then(sucRes => {
						console.log(sucRes);
					});
				}
			}
		}, 500);

		// this.myTimer = setInterval(() => {
		//   console.log(this.myTimer);
		//   if (this.DefaultAddress != null) {
		//     clearInterval(this.myTimer);
		//     this.myTimer = null;
		//     this.getPickupPriceList();
		//   }
		// }, 500);

		if (this.$route.params.name && this.$route.params.name.length) {
			this.name = this.$route.params.name;
			//根据标识获取商户信息
			this.getBusinessInfo();
			//获取商户列表
			this.getBusinessAddressList();
      this.setTime = '12:00';
		}

		if (this.$route.params.back && this.$route.params.back.length) {
			if (this.$route.params.back == 'back') {
				this.isGo = false;
        // this.isGo = true;
				this.$store.commit('appoint/setData', {
					isGo: this.isGo
				});
				let tmpDate = new Date();
				tmpDate.setTime(tmpDate.getTime() + 130 * 60 * 1000);
				this.setTime = baseTool.dateFormat(tmpDate, 'HH:mm');
			}
		}
		if (this.$route.params.limit && this.$route.params.limit.length) {
			if (this.$route.params.limit == 'nolimit') {
				this.noLimit = true;
				let tmpDate = new Date();
				tmpDate.setTime(tmpDate.getTime() + 10 * 60 * 1000);
				this.setTime = baseTool.dateFormat(tmpDate, 'HH:mm');
				this.setBackTime();
			}
		}
		if (this.$route.params.from && this.$route.params.from.length) {
			this.fromParams = this.$route.params.from;
		}

    this.setDate = '';
    if(this.bookingDate==''){
      this.setDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
    }
    else{
      this.setDate = this.bookingDate.substring(0,10);
    }
	},
  created() {
    this.setDate = '';
  	if(this.bookingDate==''){
  	  this.setDate = baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
  	}
  	else{
  	  this.setDate = this.bookingDate.substring(0,10);
  	}
  },
	components: {
		'hq-header': Header,
		'public-order-input': InputInfo,
		Swiper,
		publicBusinessInfo
	},
	methods: {
		setBackTime() {
			let that = this;
			this.fareTimer = setInterval(() => {
				clearInterval(that.fareTimer);
				that.setFareTime();
			}, 3000);
		},
		setRental(val) {
			this.isRental = val;
		},
		decPrice(val) {
			if (this.selectedPickupPriceModel.BackPrice - this.carPoolPrice == this.decCount) {
				this.$Message.warning('最大优惠为10%哦，只能减这么多了。');
			} else {
				this.carPoolPrice -= val;
			}
		},
		computedAvableTime() {
			var that = this;
			this.avableShowFrequencyTime = baseTool.formatterDateTime(new Date());
      var todayTenHour = baseTool.formatterDate(new Date()) + ' 10:00';
			// var todayTenHour = baseTool.formatterDate(new Date()) + ' 08:00';
			this.todayAfterSixHour = baseTool.formatterDate(new Date()) + ' 18:00';
			this.nowTime = baseTool.formatterDateTime(new Date());
			var val = baseTool.compareDateEndTimeGTStartTime(this.nowTime, todayTenHour); // nowTime=2018-11-12 15:04比较todayTenHour=2018-11-12 10:00 false
			var val2 = baseTool.compareDateEndTimeGTStartTime(this.nowTime, this.todayAfterSixHour); // nowTime=2018-11-12 15:04比较todayAfterSixHour=2018-11-12 18:00 true

			//2020-4-25 3小时以后时间
			this.nowThreeHoursTime = baseTool.addHour(new Date(), 3);
			console.log('this.nowThreeHoursTime=>', this.nowThreeHoursTime);

			if (val) {
				// 仍然未过当天10点，则下午1点以后的所有班次都可以显示
				this.avableShowPickupFrequencyTime = baseTool.formatterDate(new Date()) + ' 12:30';
			} else if (val2) {
				// 仍然未过当天下午6点，则可以查看隔天的全部接送班次，当天则不可以。
				this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 01:00';
			} else {
				this.avableShowPickupFrequencyTime = baseTool.addDate(new Date(), 1) + ' 12:30';
			}
			// console.log('avableShowFrequencyTime->', this.avableShowFrequencyTime);
			// console.log('avableShowPickupFrequencyTime->', this.avableShowPickupFrequencyTime);
		},
		selectstartAddress() {
			this.$router.push({
				name: 'MyAddressManager',
				params: {
					mode: 'choose'
				}
			});
		},
		addNewAddress() {
			// 跳转到添加地址页
			this.$router.push({
				name: 'EditAddress',
				params: {
					type: 'add',
					id: 0
				}
			});
		},
		getBusinessInfo() {
			//获取商户信息
			businessApi.getBusinessInfo(this.name).then(res => {
				if (res.success) {
					this.businessInfo = res.data;
					this.$store.commit('appoint/setData', { businessSign: this.name }); // new
				}
			});
		},
		getBusinessAddressList() {
			//获取商户地址列表
			businessApi.getBusinessAddressList(this.name).then(res => {
				// console.log(res);
				if (res.success) {
					this.businessAddressList = res.data;
					console.log(this.businessAddressList);
					this.businessAddressList.forEach(item => {
						if (item.IsDefault) {
							this.endAddress = item.MarkName;
							this.$store.commit('appoint/setData', {
								MarkName: item.MarkName, // new
								bookingEndAddr: item.Address,
								bookingEndPointLo: item.Longitude,
								bookingEndPointLa: item.Latitude
							});
							// this.getPickupPriceList();
						}
					});
				}
			});
		},
		getPickupPriceList() {
			this.pickupPriceList = [];
			this.$Spin.show();
			businessApi.getBusinessPickupPriceList(this.name, this.$store.state.appoint.MarkName).then(sucRes => {
				this.$Spin.hide();
				if (sucRes.success && sucRes.data.length > 0) {
					this.pickupPriceList = sucRes.data;
					for (let i = 0; i < this.pickupPriceList.length; i++) {
						if (this.pickupPriceList[i].District == this.DefaultAddress.District) {
							this.selectedPickupPriceModel = this.pickupPriceList[i];
							break;
						}
					}
					this.makePriceTable();
				} else {
					this.$Message.warning('没有该点的接送报价！');
				}
			});
		},
		// 生成价格表
		makePriceTable() {
			let tmpPriceArr = [];
			this.priceTable = [];
			for (let i = 0; i < this.pickupPriceList.length; i++) {
				if (this.pickupPriceList[i].Status) {
					if (this.isGo) {
						let tmpPrice = this.pickupPriceList[i].Price;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					} else {
						let tmpPrice = this.pickupPriceList[i].BackPrice;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					}
				}
			} // 生成价格数组
			tmpPriceArr.sort((val1, val2) => {
				return val1 - val2;
			});
			for (let i = 0; i < tmpPriceArr.length; i++) {
				let tmpDistrictStr = '';
				for (let j = 0; j < this.pickupPriceList.length; j++) {
					if (this.isGo) {
						if (this.pickupPriceList[j].Price == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					} else {
						if (this.pickupPriceList[j].BackPrice == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					}
				}
				tmpDistrictStr = tmpDistrictStr.substring(0, tmpDistrictStr.length - 1);
				let priceComputedDescription = '';
				priceComputedDescription += Math.round(tmpPriceArr[i]) + '/1人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 2 * 0.8) + '/2人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 3 * 0.7) + '/3人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 4 * 0.6) + '/4人';
				var tmpObj = { District: tmpDistrictStr, singlePrice: tmpPriceArr[i], doublePrice: tmpPriceArr[i] * 2, priceComputedDescription: priceComputedDescription };
				this.priceTable.push(tmpObj);
			}
		},
		showWarningTips() {
			this.showMask = !this.showMask;
		},
		selectEndAddress() {
			//选择商户地址列表
			let addressList = [];
			let that = this;
			console.log(this.businessAddressList);
			if (this.businessAddressList.length) {
				for (let i = 0; i < this.businessAddressList.length; i++) {
					let addressLiatTmp = {
						label: this.businessAddressList[i].MarkName,
						value: this.businessAddressList[i].MarkName
					};
					addressList.push(addressLiatTmp);
				}
			}
			this.$weui.picker(addressList, {
				onConfirm: result => {
					this.endAddress = result[0].value;
					let tmp = null;
					this.businessAddressList.forEach(item => {
						if (item.MarkName == this.endAddress) {
							tmp = item;
						}
					});
					console.log(tmp);
					this.$store.commit('appoint/setData', {
						MarkName: tmp.MarkName, // new
						bookingEndAddr: tmp.Address,
						bookingEndPointLo: tmp.Longitude,
						bookingEndPointLa: tmp.Latitude
					});
					this.getPickupPriceList();
				}
			});
		},
		changeStartEnd() {
			//对调
			this.isGo = !this.isGo;
			this.$store.commit('appoint/setData', {
				isGo: this.isGo
			});

			if (!this.isGo && this.noLimit) {
				this.setFareTime();
			}
			// this.makePriceTable();
		},
		selectSetDate(date) {
			//日期
			let that = this;
      console.log('date',date)
      if(date<baseTool.dateFormat(new Date(), 'yyyy-MM-dd')){
        this.$Message.warning('乘车日期不得小于当前日期');
        this.setDate=baseTool.dateFormat(new Date(), 'yyyy-MM-dd');
      }
      else{
        this.setDate=date;
        this.$store.commit('appoint/setData', {
          bookingDate: this.setDate + ' ' + this.setTime
        });
      }

			// this.$weui.datePicker({
			// 	start: new Date(), // 从今天开始
			// 	// end: baseTool.addDate(new Date(), 60),
   //      end: baseTool.addDate(new Date(), 600),
			// 	// defaultValue: startDate,
			// 	onConfirm: result => {
			// 		// that.submitInfo.bookDate = result[0].value + "-" + result[1].value + "-" + result[2].value;
			// 		this.setDate = result[0].value + '-' + (result[1].value >= 10?result[1].value:'0'+result[1].value) + '-' + (result[2].value >= 10?result[2].value:'0'+result[2].value);
			// 		if (this.setTime != '') {
			// 			this.$store.commit('appoint/setData', {
			// 				bookingDate: this.setDate + ' ' + this.setTime
			// 			});
			// 		}
			// 	}
			// });
		},
		setDateTime() {
			//时间
			let _this = this;
			var hours = [],
				minutes = [],
				symbol = [
					{
						label: ':',
						value: 0
					}
				];
			if (!hours.length) {
				for (let i = 4; i <= 22; i++) {
					var hours_item = {};
					hours_item.label = ('' + i).length == 1 ? '0' + i : '' + i;
					hours_item.value = i;
					hours.push(hours_item);
				}
			}
			minutes = [
				{ label: '00', value: '00' },
				{ label: '10', value: '10' },
				{ label: '20', value: '20' },
				{ label: '30', value: '30' },
				{ label: '40', value: '40' },
				{ label: '50', value: '50' }
			];
			this.$weui.picker(hours, symbol, minutes, {
				onConfirm: result => {
					// this.setTime = result[0].label + ':' + result[2].label;
					this.setTime = result[0].label + ':' + result[2].label;
					if (this.setDate != '') {
						this.$store.commit('appoint/setData', {
							bookingDate: this.setDate + ' ' + this.setTime
						});
					}
				}
			});
		},
		checkInput() {
			if (this.setDate == '' || this.setTime == '') {
				// this.$Message.warning('次日12:30分前接送服务，需提前一天18:00分前购买，当天12:30分后的接送服务，需于当天10:00前购买。');
				this.$Message.warning('当天09:00以前的班车接送，在乘车前一天下午18:00左右通知实际接送乘车时间，当天09:00以后的班车接送，在确认订单后通知实际接送乘车时间。');
				return false;
			}
			let bookingDate = this.setDate + ' ' + this.setTime;
			if (this.isGo) {
				// 去程接送时间验证
				// let canPickup = baseTool.compareDateEndTimeGTStartTime(this.avableShowPickupFrequencyTime, bookingDate);
				this.nowThreeHoursTime = baseTool.addHour(new Date(), 1.5);
        // this.nowThreeHoursTime = baseTool.addHour(new Date(), 1);
				console.log(this.nowThreeHoursTime);
				let canPickup = baseTool.compareDateEndTimeGTStartTime(this.nowThreeHoursTime, bookingDate);
				if (!canPickup) {
					// alert('次日12:30分前接送服务，需提前一天18:00分前购买，当天12:30分后的接送服务，需于当天10:00前购买。');
					alert('当天09:00以前的班车接送，在乘车前一天下午18:00左右通知实际接送乘车时间，当天09:00以后的班车接送，在确认订单后通知实际接送乘车时间。');
					return false;
				} else return true;
			} else {
				// 返程接送时间验证
				if (this.noLimit)
					// 若传入无须验证时间，则直接通过回程购买。
					return true;
				else {
					// 需要验证时间
					let isAfterSix = baseTool.compareDateEndTimeGTStartTime(baseTool.formatterDateTime(new Date()), this.todayAfterSixHour); // nowTime=2018-11-12 15:04比较todayAfterSixHour=2018-11-12 18:00 true
					// 当天下午6点前
					if (isAfterSix) {
						// 验证bookingDate是否距当前时间2小时以上
						let isAboveTowHour = baseTool.compareDateEndTimeGTStartTime(baseTool.addHour(new Date(), 1), bookingDate);
						console.log('isAboveTowHour=>', isAboveTowHour);
						if (isAboveTowHour) return true;
						else {
							alert('回程接送需在当天18:00前提前1小时购买。');
							return false;
						}
					} else {
						// 当天下午6点后
						let canPickup = baseTool.compareDateEndTimeGTStartTime(this.avableShowPickupFrequencyTime, bookingDate);
						if (!canPickup) {
							alert('当天17:00后不能再购买当天的回程接送。');
							return false;
						} else return true;
					}
				}
			}
		},
		gotoOrderPage() {
			let that = this;
			//跳转
			// new
      // this.setDate = baseTool.dateFormat(this.setDate, 'yyyy-MM-dd')
      console.log('setDate',this.setDate )

      // console.log('this.DefaultAddress.Address',this.DefaultAddress.Address )
      if(this.DefaultAddress.Address.indexOf('中山懿峰候机楼') != -1){
        this.$Message.warning('出发地与目的地不得一样');
        // 回程接送需求请回到候机楼前台咨询
        return;
      }

      if(this.setDate == ''){
        this.$Message.warning('请选择乘车日期');
        return;
      }
      if(this.setTime == ''){
        this.$Message.warning('请选择期望时间');
        return;
      }

      var selectTime = this.setDate + ' ' + this.setTime;//客户选择的时间
      console.log('setDate',this.setDate )
      console.log('setTime',this.setTime )
      console.log('selectTime',this.setDate + ' ' + this.setTime )

      appointApi.CheckAppointOrderbookingDate(selectTime).then(sucRes => {
        console.log(sucRes);
        if(sucRes.success==true){
          if (this.DefaultAddress.Address != '') {
          	this.$Spin.show();

          	appointApi.convertAddressToLocation(this.DefaultAddress.City, this.DefaultAddress.Address).then(sucRes => {
          		if (sucRes.status == '1' && sucRes.info == 'OK' && sucRes.pois && sucRes.pois.length > 0) {
          			console.log('sucRes=>', sucRes);
          			this.$Spin.hide();
          			let location = sucRes.pois[0].location;
          			appointApi.convertLocationToAddress(location).then(sucRes2 => {
          				console.log('sucRes2=>', sucRes2);
          				if (sucRes2.status == '1' && sucRes2.info == 'OK') {
          					let district = sucRes2.regeocode.addressComponent.township;
          					let addressStr = sucRes2.regeocode.formatted_address;
          					if (this.DefaultAddress.District != district) {
          						alert(
          							`当前地址所选行政区[${this.DefaultAddress.District}-${
          								this.DefaultAddress.Address
          							}]与地图计算行政区结果[${district}-${addressStr}]不符，不能进行正确计费，请致电0760-88880777反映相关情况，或更改相关地址信息后重试。`
          						);
          					} else {
          						that.$store.commit('appoint/setData', {
          							bookingStartAddr: that.DefaultAddress.Address,
          							bookingStartPointLa: location.split(',')[1],
          							bookingStartPointLo: location.split(',')[0],
          							bookingDate: that.setDate + ' ' + that.setTime
          						});
          						that.getFarePrediction(that.DefaultAddress.Address, location.split(',')[1], location.split(',')[0]);
          						that.showConfirmView();
          					}
          				}
          			});
          		} else {
          			this.$Message.warning('当前地址计算座标失败！');
          		}
          	});
          } else {
          	this.$Message.warning('请选择接送地址');
          	// this.selectstartAddress();
          	this.addNewAddress();
          }
        }
        else if(sucRes.success==false){
          this.$Message.warning(sucRes.data);
        }
      })

      //aaa
      // var date = new Date()
      // var y = date.getFullYear()
      // var m = date.getMonth() + 1
      // m = m < 10 ? ('0' + m) : m
      // var d = date.getDate()
      // d = d < 10 ? ('0' + d) : d
      // var h = date.getHours()
      // h = h < 10 ? ('0' + h) : h

      // if(h >= '09'){
      //   var time = y + '-' + m + '-' + d
      // }
      // else{
      //   var time = y + '-' + m + '-' + d
      //   var timestamp = Date.parse(time);
      //   var yesterdayTimetamp = timestamp - 86400000

      //   var yesterdayDate = new Date(yesterdayTimetamp)
      //   var yesterdayY = yesterdayDate.getFullYear()
      //   var yesterdayM = yesterdayDate.getMonth() + 1
      //   yesterdayM = yesterdayM < 10 ? ('0' + yesterdayM) : yesterdayM
      //   var yesterdayD = yesterdayDate.getDate()
      //   yesterdayD = yesterdayD < 10 ? ('0' + yesterdayD) : yesterdayD

      //   time = yesterdayY + '-' + yesterdayM + '-' + yesterdayD

      // }


      // var selectTime = this.setDate + ' ' + this.setTime;//客户选择的时间
      // var selectTimestamp = Date.parse(selectTime);//客户选择的时间（时间戳）
      // var today = time;//当天日期
      // var nowTime = Date.parse(new Date());//当天日期（时间戳）
      // var todayEightAm = Date.parse(today + ' ' + '09:00');//当天早上9点（时间戳）
      // var todayEightPm = Date.parse(today + ' ' + '18:00');//当天下午18点（时间戳）
      // var tomorrowEightAm = todayEightPm + 43200000;//第二天早上9点（时间戳）

      // console.log('setDate',this.setDate )
      // console.log('setTime',this.setTime )
      // console.log('Time',this.setDate + ' ' + this.setTime )
      // console.log('today',today)
      // console.log('setTime',selectTime)
      // console.log('selectTimestamp',selectTimestamp)
      // console.log('nowTime',nowTime)
      // console.log('todayEightAm', todayEightAm)
      // console.log('todayEightPm', todayEightPm)
      // console.log('tomorrowEightAm', tomorrowEightAm)

      // //今日
      // // if(today == this.setDate){
      //   //当前时间与今日18点到第二日9点
      //   if(nowTime >= todayEightPm && nowTime <= tomorrowEightAm){
      //     if(selectTimestamp >= todayEightPm && selectTimestamp <= tomorrowEightAm){
      //       // this.$Message.warning('当天下午17点后至明天早上9点前的出行时间必须选择明天早上9点后的时间！');
      //       this.$Message.warning('当天下午18点后至明天早上9点前的出行时间必须选择明天早上9点后的时间！');
      //       return;
      //     }
      //   }

      //   //客户选择时间与今日12点到今日18点
      //   // if((selectTime < (today + ' ' + '12:00')) || (selectTime > (today + ' ' + '18:00'))){
      //   //   this.$Message.warning('bbbbbbbb');
      //   //   return;
      //   // }

      //   //客户选择时间与今日18点
      //   if(selectTime >= (this.setDate + ' ' + '18:00')){
      //     // this.$Message.warning('出行时间不得在下午18点后！');
      //     this.$Message.warning('出行时间不得在下午18点后！');
      //     return;
      //   }
      //   //客户选择时间与当前时间3小时
      //   if(selectTimestamp <= (nowTime+10800000)){
      //     this.$Message.warning('请提前3小时预订！');
      //     return;
      //   }
      //bbb
      // }
      //听日
      // if(today != this.setDate){
      //   if(nowTime > todayEightPm && nowTime < tomorrowEightAm){
      //     this.$Message.warning('aaaaaaaa');
      //     return;
      //   }
      // }

			// let checked = this.checkInput();
			// if (!checked) {
			// 	return;
			// }
		},
		closeConfirmView() {
			this.isShowMap = false;
		},
		showConfirmView() {
			let that = this;
			this.carPoolPrice = 0;
			this.rentalPrice = 0;
			this.isAbleToRental = false;
			this.isRental = false;

			let startAddr = this.isGo ? this.DefaultAddress.Address : this.endAddress;
			let startCity = this.isGo ? this.DefaultAddress.City : this.$store.state.appoint.CityName;
			let endAddr = this.isGo ? this.endAddress : this.DefaultAddress.Address;
			let endCity = this.isGo ? this.$store.state.appoint.CityName : this.DefaultAddress.City;

			this.isShowMap = true;
			this.$nextTick(() => {
				that.map = new AMap.Map('allMap', {
					resizeEnable: true, //是否监控地图容器尺寸变化
					zoom: 18 //初始化地图层级
					// center: [116.397428, 39.90923] //初始化地图中心点
				});
				//构造路线导航类
				let driving = new AMap.Driving({
					map: that.map
					// panel: 'panel'
				});
				// 根据起终点名称规划驾车导航路线
				driving.search([{ keyword: startAddr, city: startCity }, { keyword: endAddr, city: endCity }], (status, result) => {
					// result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
					if (status == 'complete' && result.info == 'OK') {
						console.log(result);
						let time = result.routes[0].time;
						let distance = result.routes[0].distance;
						that.duration = Math.round(time / 60);
						that.kilos = Math.round(distance / 1000);

						let StraighDistance = baseTool.getDistance(
							Math.abs(that.$store.state.appoint.bookingStartPointLa),
							Math.abs(that.$store.state.appoint.bookingStartPointLo),
							Math.abs(that.$store.state.appoint.bookingEndPointLa),
							Math.abs(that.$store.state.appoint.bookingEndPointLo)
						);

						let longDistance = Math.ceil(StraighDistance / 1000);
						that.LongDistance = longDistance;

						console.log(
							Math.abs(that.$store.state.appoint.bookingStartPointLa),
							Math.abs(that.$store.state.appoint.bookingStartPointLo),
							Math.abs(that.$store.state.appoint.bookingEndPointLa),
							Math.abs(that.$store.state.appoint.bookingEndPointLo),
							StraighDistance,
							longDistance
						);
						// if (longDistance >= 4) {
						that.isAbleToRental = true;
						// }
						that.rentalPrice += 15;
						// for (let i = 1; i <= longDistance; i++) {
						// 	if (i > 2 && i <= 10) that.rentalPrice += 3;
						// 	if (i > 10 && i <= 20) that.rentalPrice += 4;
						// 	if (i > 20 && i <= 30) that.rentalPrice += 5;
						// 	if (i > 30) that.rentalPrice += 6;
						// }
						that.carPoolPrice += 15;
						if (longDistance > 2) that.carPoolPrice += (longDistance - 2) * 3;

						let appointHour = that.setTime.replace(':', '');
						console.log('appointHour=>', appointHour);

						if (longDistance < 10) {
							if (that.carPoolPrice > 15) {
								that.carPoolPrice = Math.ceil(that.carPoolPrice * 0.9);
							}
						} else if (longDistance >= 10 && longDistance < 15) {
							// that.rentalPrice = that.rentalPrice + Math.ceil(that.rentalPrice * 0.05);
						} else if (longDistance >= 15 && longDistance < 20) {
							that.carPoolPrice = that.carPoolPrice + Math.ceil(that.carPoolPrice * 0.05);
							// that.rentalPrice = that.rentalPrice + Math.ceil(that.rentalPrice * 0.08);
						} else if (longDistance >= 20 && longDistance < 25) {
							that.carPoolPrice = that.carPoolPrice + Math.ceil(that.carPoolPrice * 0.1);
							// that.rentalPrice = that.rentalPrice + Math.ceil(that.rentalPrice * 0.1);
						} else if (longDistance >= 25 && longDistance < 30) {
							that.carPoolPrice = that.carPoolPrice + Math.ceil(that.carPoolPrice * 0.15);
							// that.rentalPrice = that.rentalPrice + Math.ceil(that.rentalPrice * 0.15);
						} else if (longDistance >= 30) {
							that.carPoolPrice = that.carPoolPrice + Math.ceil(that.carPoolPrice * 0.15);
							// that.rentalPrice = that.rentalPrice + Math.ceil(that.rentalPrice * 0.2);
						}

						if (parseInt(appointHour) <= 720) {
							that.carPoolPrice += 10;
							that.estimatedAmount += 10;
							// if (that.rentalPrice != 0) that.rentalPrice += 10;
						}
						// New Start
						let isOverTime = false;

						if (parseInt(appointHour) >= 2200 || parseInt(appointHour) <= 500) {
							isOverTime = true;
						}
						// console.log('isOverTime->', parseInt(appointHour) >= 2200 + 'appointHour->' + parseInt(appointHour));
						for (let i = 3; i <= that.kilos; i++) {
							if (i <= 12) {
								if (!isOverTime) {
									that.rentalPrice += 2.72;
								} else {
									that.rentalPrice += 3.12;
								}
							} else if (i > 12) {
								if (!isOverTime) {
									that.rentalPrice += 3.52;
								} else {
									that.rentalPrice += 4.04;
								}
							}
						}
						that.rentalPrice = Math.round(that.rentalPrice);
						that.carPoolPrice = that.rentalPrice;
						// New End
            console.log('接送车原价（未提升％10）：' + that.carPoolPrice);
            // newrentalPrice.indexOf(".")==-1||newrentalPrice.indexOf(".5")!=-1?newrentalPrice:Math.round(newrentalPrice*2+0.5)/2

            that.ShowCarPoolPrice = String(that.carPoolPrice+(that.carPoolPrice*0.1));

            that.ShowCarPoolPrice = that.ShowCarPoolPrice.indexOf(".")==-1||that.ShowCarPoolPrice.indexOf(".5")!=-1?that.ShowCarPoolPrice:Math.round(that.ShowCarPoolPrice*2+0.5)/2;



						if (that.carPoolPrice > that.estimatedAmount) that.estimatedAmount = that.carPoolPrice + 2;
            console.log('对比价：' + that.carPoolPrice);
					} else {
						console.log('获取驾车数据失败：' + result);
					}
				});
			});
		},
		getFarePrediction(bookingStartAddr, bookingStartPointLa, bookingStartPointLo) {
			let that = this;
			let postData = {
				bookingDate: this.$store.state.appoint.bookingDate,
				serviceType: this.$store.state.appoint.serviceType,
				bookingStartAddr: this.isGo ? bookingStartAddr : this.endAddress,
				bookingStartPointLo: this.isGo ? bookingStartPointLo : this.$store.state.appoint.bookingEndPointLo,
				bookingStartPointLa: this.isGo ? bookingStartPointLa : this.$store.state.appoint.bookingEndPointLa,
				bookingEndAddr: this.isGo ? this.endAddress : bookingStartAddr,
				bookingEndPointLo: this.isGo ? this.$store.state.appoint.bookingEndPointLo : bookingStartPointLo,
				bookingEndPointLa: this.isGo ? this.$store.state.appoint.bookingEndPointLa : bookingStartPointLa,
				city: this.$store.state.appoint.CityName
			};
			appointApi.getFarePrediction(postData).then(sucRes => {
				if (sucRes.success && sucRes.data.amounts && sucRes.data.amounts.length > 0) this.estimatedAmount = Math.round(sucRes.data.amounts[0].amount * 1.6);
				else {
					this.isRental = false;
					this.estimatedAmount = '计价失败！';
				}
			});
		},
		setFareTime() {
			let that = this;
			wx.getLocation({
				type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
				success: res => {
					let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
					let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
					let speed = res.speed; // 速度，以米/每秒计
					let accuracy = res.accuracy; // 位置精度
					that.$store.commit('user/setLocation', longitude + ',' + latitude);

					// let postData = {
					// 	bookingDate: this.$store.state.appoint.bookingDate,
					// 	serviceType: this.$store.state.appoint.serviceType,
					// 	bookingStartAddr: this.isGo ? bookingStartAddr : this.endAddress,
					// 	bookingStartPointLo: this.isGo ? bookingStartPointLo : this.$store.state.appoint.bookingEndPointLo,
					// 	bookingStartPointLa: this.isGo ? bookingStartPointLa : this.$store.state.appoint.bookingEndPointLa,
					// 	bookingEndAddr: this.isGo ? this.endAddress : bookingStartAddr,
					// 	bookingEndPointLo: this.isGo ? this.$store.state.appoint.bookingEndPointLo : bookingStartPointLo,
					// 	bookingEndPointLa: this.isGo ? this.$store.state.appoint.bookingEndPointLa : bookingStartPointLa,
					// 	city: this.$store.state.appoint.CityName
					// };
					appointApi
						.driverSearch(longitude + ',' + latitude, this.$store.state.appoint.bookingEndPointLo + ',' + this.$store.state.appoint.bookingEndPointLa)
						.then(sucRes => {
							if (sucRes.status == '1' && sucRes.info == 'OK' && sucRes.route.paths.length > 0) {
								let driverDistance = sucRes.route.paths[0].distance;
								let driverDuration = sucRes.route.paths[0].duration;
								let driverKilo = Math.round(driverDistance / 1000);
								let driverMinutes = Math.round(driverDuration / 60);
								let desDriverMinute = driverMinutes + 10;
								let furtureTime = new Date();
								furtureTime.setTime(new Date().getTime() + 60 * desDriverMinute * 1000);
								that.setTime = baseTool.dateFormat(furtureTime, 'HH:mm');
							}
						});
				}
			});
		},
		confirmAddress() {
			let that = this;

      var newrentalPrice = String(that.rentalPrice+(that.rentalPrice*0.1));
      var newcarPoolPrice = String(that.carPoolPrice+(that.carPoolPrice*0.1));


      newrentalPrice = newrentalPrice.indexOf(".")==-1||newrentalPrice.indexOf(".5")!=-1?newrentalPrice:Math.round(newrentalPrice*2+0.5)/2;
      newcarPoolPrice = newcarPoolPrice.indexOf(".")==-1||newcarPoolPrice.indexOf(".5")!=-1?newcarPoolPrice:Math.round(newcarPoolPrice*2+0.5)/2;

      console.log('原价格',that.isRental ? that.rentalPrice:that.carPoolPrice)
      // console.log('新价格',that.isRental ? that.rentalPrice+(that.rentalPrice*0.1) : that.carPoolPrice+(that.carPoolPrice*0.1))

      console.log('新价格',that.isRental ? newrentalPrice : newcarPoolPrice)



			this.closeConfirmView();
			this.$router.push({
				name: 'order-page',
				params: {
					limit: that.noLimit ? 'nolimit' : 'limit',
					from: that.fromParams,
					isrental: that.isRental,
					price: that.isRental ? Number(newrentalPrice) : Number(newcarPoolPrice)
				}
			});
		}
	},
	//使用mapState模块映射数据
	computed: mapState({
		DefaultAddress: state => state.ticket.DefaultAddress,
		bookingDate: state => state.appoint.bookingDate
	})
};
// style scoped lang="less"
</script>


<style lang="less">
@import '../style/public';

.public-order-page {
	justify-content: initial;
	.business-info {
		background-color: #fff;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 10px;
	}
	.notice {
		.blockPadding(0, 0.5rem);
		.red-text;
	}
}

.inputs_wrap {
	width: 93%;
	margin: 15px auto 0;
	background-color: #fff;
	position: relative;
	// .shadow(10px, 0, 0, rgba(0, 0, 0, 0.4));
	.radius;
	.blockPadding(0, 10px);

	.user-info-input {
		.flex_wrap(initial, center);
		.blockPadding(0.2rem, 0);
		padding-left: 0.2rem;
		&:first-child {
			margin-right: 1rem;
		}
		& .iconfont {
			margin-right: 5px;
			font-size: 0.4rem;
		}
		& > span {
			// padding-right: 10px;
		}

		& > span:first-child {
			// .border-R;
			.flex_items(auto, 0, 0);
			text-align: left;
		}

		& > input,
		& > span:last-child {
			border: none;
			background-color: transparent;
			.blockPadding(0, 10px);
		}

		// &>span:last-child{}
	}
	.exchange {
		position: absolute;
		.wh(1.2rem, 1.2rem);
		.flex_wrap(center, center);
		top: 0.8rem;
		right: 0;
	}

	.text-center {
		& > button {
			margin: 0 auto;
		}
	}

	& > .user-info-input:nth-last-child(n + 2) {
		// .border-B(1px, solid);
	}
}

.btn_wrap {
	text-align: center;
	.margin-Tb(0.3rem, 0);
}
.big-btn {
	button {
		width: 90%;
		.btn();
		.radius;
		.primarybtnColor;
		// .shadow(8px);
	}
}

.exchange-btn {
	position: relative;
	background-color: transparent;
	width: 0.7rem;
	height: 0.7rem;
	// .shadow(5px);

	& > i {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-45%, -50%);
		font-size: 0.4rem;
		color: #fff;
		// text-shadow: 0 0 5px #e77618;
		z-index: 2;
	}

	text-align: center;
	// .flex_wrap(center,center);
	// background-color: #E7761852;
	.radius(50%);
	.btn;

	&:after {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #e77618;
		opacity: 0.8;
		z-index: 1;
		.radius(50%);
	}
}

#panel {
	position: fixed;
	background-color: white;
	max-height: 90%;
	overflow-y: auto;
	top: 10px;
	right: 10px;
	width: 280px;
}
#panel .amap-call {
	background-color: #009cf9;
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}
#panel .amap-lib-driving {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	overflow: hidden;
}
#allMap {
	width: 100%;
	height: 50%;
	max-height: 50%;
}

/*iconfont*/
.mask_container_mapwrap {
	width: 100%;
	height: 95%;
	overflow: scroll;
	margin: auto;
	border-radius: 10px;
	background-color: #fff;
	transform: scale(0);
	transition: all 0.4s;
	padding: 3%;
	position: absolute;
}

.j_c_center {
	justify-content: center;
}
.a_i_center {
	align-items: center;
}
.flex_wrap {
	display: flex !important;
}
.mask_show {
	z-index: 100;
	opacity: 1;
}
.mask_show > .scale_up {
	transform: scale(1);
}
.btn_wrap {
	width: 100%;
	text-align: center;
	margin: 0 0 1em;
}
.btn {
	padding: 0 3%;
	text-indent: 5px;
	letter-spacing: 5px;
	font: 600 0.4rem/1rem '微软雅黑';
	border-radius: 5px;
	// border: 1px solid #888;
	// box-shadow: 0 0 5px #586c94;
	margin: 5px auto;
}
.article_title {
	font-size: 0.5rem;
	text-align: center;
	line-height: 6vh;
	font-weight: 600;
}
.red_color {
	color: #e22222;
}

.radio-box {
	display: inline-block;
	position: relative;
	height: 25px;
	line-height: 25px;
	margin-right: 5px;
}
.radio {
	display: inline-block;
	width: 25px;
	height: 25px;
	vertical-align: middle;
	cursor: pointer;
	// background-image: url(../../../common/images/radio.png);
	background-repeat: no-repeat;
	background-position: 0 0;
}
.input-radio {
	display: inline-block;
	position: absolute;
	opacity: 0;
	width: 25px;
	height: 25px;
	cursor: pointer;
	left: 0px;
	outline: none;
	-webkit-appearance: none;
}
.on {
	background-position: -25px 0;
}
.ivu-input{
  height: auto !important;
  padding: 0 3px 0 0 !important;
  border: none !important;
  color: black !important;
  background: none !important;
  background-image: none !important;
}
.ivu-input:focus {
  border:none !important;
  box-shadow: none !important;
}
.ivu-input-suffix i {
  line-height: 0px;
  margin-top: -5px;
}
.weui-cells:after{
  border:none;
}
.weui-cells:before{
  border:none;
}
</style>



// WEBPACK FOOTER //
// src/components/HqPublicOrderPage.vue